import { Component, Injectable } from "@angular/core";

// import { Amplify } from 'aws-amplify';
import { environment } from "../../../../../../environments/environment";
import { AppConstants } from "./app-constants";
// import { GraphQLResult, generateClient } from 'aws-amplify/api';

// import { graphqlOperation } from '@aws-amplify';

import {
  CpAssignedCar,
  CpAssignedCarModel,
} from "../../model/cpAssignedCar.model";
import {
  ListVehicleMastersModel,
  InputvehicleMaster,
  ListCpVehicleMaintenanceModel,
} from "../../model/vehicle.model";

import {
  createVehicleMasterQueries,
  updateVehicleMasterQueries,
  listcpVehicleMaintenanceQueries,
  getVehicleMasterQueries,
  updatecpVehicleMaintenanceQueries,
  filterByVehicleIDQueries,
  getDaVehicleMaster,
  filterByVehicleStatusQueries,
  getCpAssignedCarQueries,
  filterByCpAssignedCarQueries,
  updateassignedCarQueries,
  surrenderVehicleMasterQueries,
  updateVehicleMasterStatusQueries,
  getReturnAttachmentQueries,
} from "../../graphql/vehicle.queries";
import { RncUsersModel, daVehicalMasterModel } from "../../model/user.model";
import { findUserQueries } from "../../graphql/user.queries";
import { daVehicleMasterModel } from "../../model/drivers.model";
import { daVehicleMaster } from "../../graphql/drivers.queries";

import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";
import { HttpClient } from "@angular/common/http";
import { TableConstants } from "../../../../../constants/table-constants";
import { HttpUtilsService } from "../../../../../service/httputils.service";
let url = environment.pg_dburl[window.location.origin];
interface VehicleMasterRow {
  vehicle_master: any;
  agency: any;
}
//const client = generateClient();

// let myAppConfig = environment.myAppConfig;

// Amplify.configure(myAppConfig);

// Amplify.configure({
//   API: {
//     GraphQL: {
//       endpoint:
//         'https://w4tjgxrxvnguldsclbiqylytm4.appsync-api.ap-south-1.amazonaws.com/graphql',
//       region: 'ap-south-1',
//       //aws_appsync_authenticationType: "API_KEY",
//       defaultAuthMode: 'apiKey',
//       apiKey: 'da2-xi2l46vzbrgkpgjgofklofst4m',
//     },
//   },
// });

// endpoint: 'https://abcxyz.appsync-api.us-east-1.amazonaws.com/graphql',
// region: 'us-east-1',
// // Set the default auth mode to "apiKey" and provide the API key value
// defaultAuthMode: 'apiKey',
// apiKey: 'da2-xxxxxxxxxxxxxxxxxxxxxxxxxx'
//status: {eq: "ASSIGN"}
@Injectable({
  providedIn: "root",
})
//rn_id: { eq: \$rn_id } \$rn_id: String!
export class VehicleService {
  //unAssiged = 'UNASSIGNED';
  created_date: string;
  updated_date: string;
  // map_user_id = '0';
  //queryExplorer: any;

  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
    console.log("config");
    // this.filterByDriversVehicleMaster('RN07967');
    //this.filterByVendor('Relocation');
    this.created_date = this.localDateFormate();
    this.updated_date = this.localDateFormate();

    //const queryExplorer = ;
  }
  private QUERY_KEY = {
    LIST_USER: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVehicleMaster}`,
    GET_USERS: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.listCpVehicleMaster}`,
    CREATE_USERS: `${AppConstants.create}${environment.dbPrefix}${AppConstants.createCpVehicleMaster}`,
    UPDATE_USERS: `${AppConstants.update}${environment.dbPrefix}${AppConstants.updateCpVehicleMaster}`,

    list_cp_vehicle_maintenance: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpCarMaintenance}`,
    update_cp_vehicle_maintenance: `${AppConstants.list}${environment.dbPrefix}${AppConstants.UpdateCpCarMaintenance}`,

    list_da_vehicleMaster: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listDaVehicleMasters}`,
    update_da_vehicleMaster: `${AppConstants.list}${environment.dbPrefix}${AppConstants.UpdateCpCarMaintenance}`,

    cp_assigned_car_List: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpAssignedCar}`,
    get_cp_assigned_car_: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpAssignedCar}`,
  };

  localDateFormate() {
    // Assuming mydate is defined as a Date object
    const mydate = new Date();

    // Convert the date to ISO 8601 format including the local time zone offset
    const isoDateString = mydate.toISOString();

    // Alternatively, you can manually format the date string to include the local time zone offset
    const offset = -mydate.getTimezoneOffset(); // Get the offset in minutes
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const offsetSign = offset >= 0 ? "+" : "-";

    const formattedDateString = `${mydate.getFullYear()}-${this.padZero(
      mydate.getMonth() + 1
    )}-${this.padZero(mydate.getDate())}T${this.padZero(
      mydate.getHours()
    )}:${this.padZero(mydate.getMinutes())}:${this.padZero(
      mydate.getSeconds()
    )}${offsetSign}${this.padZero(offsetHours)}:${this.padZero(offsetMinutes)}`;
    console.log(formattedDateString); // Output: 2024-02-14T15:02:01+05:30
    return formattedDateString;
  }

  padZero(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }

  /****************************************************************************************
   * VEHICLE
   ***************************************************************************************/
  public async getAllVehicleMaster(
    offset: number = 0,
    limit: number = 100
  ): Promise<any> {
    const tablename = TableConstants.fnGetVehicleMasterQueries;
    //const endpoint = `${url}/${tablename}?p_limit=${limit}&p_offset=${offset}`;
    const endpoint = `${url}/${tablename}`;
    try {
      const response = await this.httpUtils.get<any[]>(endpoint);
      const items = response.map((row) => {
        const item = { ...row.vehicle_master };
        item.agency = row.vendor_detail;
        return item;
      });
      if (items) {
        return items;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching vehicle master list:", error);
      throw error;
    }
  }
  public async filterByVehicleID(
    carID?: string
  ): Promise<ListVehicleMastersModel> {
    const tablename = TableConstants.CpVehicleMaster;
    let endpoint = `${url}/${tablename}?id=eq.${carID}`;
    try {
      const response = await this.httpUtils.get<ListVehicleMastersModel>(
        endpoint
      );
      if (response) {
        console.log("Data:", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching vehicle by ID:", error);
      throw error;
    }
  }

  public async filterByVehicleStatus(
    status?: string
  ): Promise<ListVehicleMastersModel> {
    const tablename = TableConstants.CpVehicleMaster;
    let endpoint = `${url}/${tablename}?data->>ex_data=eq.${status}`;
    try {
      const response = await this.httpUtils.get<ListVehicleMastersModel>(
        endpoint
      );
      if (response) {
        console.log("Data:", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching vehicle by status:", error);
      throw error;
    }
  }

  public async createVehicleMaster(
    createdObj: any
  ): Promise<InputvehicleMaster> {
    const tablename = TableConstants.CpVehicleMaster;
    const endpoint = `${url}/${tablename}?select=*`;
    const payload = {
      agency_name: createdObj.agency_name,
      data: {
        car_model: createdObj.car_model,
        veh_reg_id: createdObj.veh_reg_id,
        policy_no: createdObj.policy_no,
        policy_from: createdObj.policy_from,
        policy_to: createdObj.policy_to,
        agency_name: createdObj.agency_name,
        lease_from: createdObj.lease_from,
        lease_to: createdObj.lease_to,
        car_type: createdObj.car_type,
        ex_data: AppConstants.REQUEST_STATUS.UNASSIGN,
        car_make: createdObj.car_make,
        car_variant: createdObj.car_variant,
        car_color: createdObj.car_color,
        fuel_type: createdObj.fuel_type,
        car_registration_date: createdObj.car_registration_date,
        chasis_number: createdObj.chasis_number,
        map_user_id: AppConstants.REQUEST_STATUS.MAP_USER_ID,
        asset_number: createdObj.asset_number,
        surrender_date: createdObj.surrender_date,
        document_code: createdObj.document_code,
        rental_month: createdObj.rental_month,
        po_number: createdObj.po_number,
        vehicle_rc_book_attachments: createdObj.vehicle_rc_book_attachments,
        insurance_policy_attachments: createdObj.insurance_policy_attachments,
        vehicle_lease_attachments: createdObj.vehicle_lease_attachments,
        created_date: this.created_date,
        updated_date: this.updated_date,
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error creating vehicle master:", error);
      throw error;
    }
  }

  // document_code: updateObj.document_code,
  // rental_month: updateObj.rental_month,
  // po_number: updateObj.po_number,

  public async updateVehicleMaster(updateObj: any): Promise<boolean> {
    const functionName = TableConstants.fnUpdate_VehicleMaster;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateObj.id,
      p_agency_name: updateObj.agency_name,
      updates: {
        car_model: updateObj.car_model,
        veh_reg_id: updateObj.veh_reg_id,
        policy_no: updateObj.policy_no,
        policy_from: updateObj.policy_from,
        policy_to: updateObj.policy_to,
        agency_name: updateObj.agency_name,
        lease_from: updateObj.lease_from,
        lease_to: updateObj.lease_to,
        car_type: updateObj.car_type,
        ex_data: updateObj.ex_data,
        car_make: updateObj.car_make,
        car_variant: updateObj.car_variant,
        car_color: updateObj.car_color,
        fuel_type: updateObj.fuel_type,
        car_registration_date: updateObj.car_registration_date,
        chasis_number: updateObj.chasis_number,
        map_user_id: AppConstants.REQUEST_STATUS.MAP_USER_ID,
        asset_number: updateObj.asset_number,
        surrender_date: updateObj.surrender_date,
        document_code: updateObj.document_code,
        rental_month: updateObj.rental_month,
        po_number: updateObj.po_number,
        vehicle_rc_book_attachments: updateObj.vehicle_rc_book_attachments,
        insurance_policy_attachments: updateObj.insurance_policy_attachments,
        vehicle_lease_attachments: updateObj.vehicle_lease_attachments,
        surrender_car_attachments: updateObj.surrender_car_attachments,
        updated_date: this.updated_date,
      },
      p_updated_date: new Date().toISOString(),
    };

    try {
      const response = await this.httpUtils.post(endpoint, payload);
      return !!response;
    } catch (error) {
      console.error("Error updating vehicle master:", error);
      return false;
    }
  }

  public async surrenderVehicle(updateObj: any): Promise<boolean> {
    const functionName = TableConstants.fnSurrenderVehicleMaster;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateObj.id,
      updates: {
        surrender_date: updateObj.surrender_date,
        surrender_car_attachments: updateObj.surrender_car_attachments,
        updated_date: this.updated_date,
        ex_data: AppConstants.REQUEST_STATUS.SURRENDER,
      },
      p_updated_date: new Date().toISOString(),
    };
    try {
      const response = await this.httpUtils.post(endpoint, payload);
      return !!response;
    } catch (error) {
      console.error("Error surrendering vehicle:", error);
      return false;
    }
  }

  public async updateVehicleStatus(updateObj: any): Promise<boolean> {
    const functionName = TableConstants.fnUpdateVehicleMasterStatus;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateObj.id,
      updates: {
        updated_date: this.updated_date,
        ex_data: AppConstants.REQUEST_STATUS.UNASSIGN,
      },
      p_updated_date: new Date().toISOString(),
    };

    try {
      const response = await this.httpUtils.post(endpoint, payload);
      return !!response;
    } catch (error) {
      console.error("Error updating vehicle status:", error);
      return false;
    }
  }

  public async returnAssignedCar(createdObj: any): Promise<boolean> {
    const functionName = TableConstants.fnUpdateReturnAssignedCar;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: createdObj.id,
      updates: {
        vehicle_return_attachments: createdObj.vehicle_return_attachments,
        car_return_date: createdObj.car_return_date,
        status: AppConstants.REQUEST_STATUS.UNASSIGN,
        vehicle_return_submission_date:
          createdObj.vehicle_return_submission_date,
        updated_date: this.updated_date,
      },
      p_updated_date: new Date().toISOString(),
    };

    try {
      const response = await this.httpUtils.post(endpoint, payload);
      return !!response;
    } catch (error) {
      console.error("Error returning assigned car:", error);
      return false;
    }
  }

  // async filterByVehicleMaster(status: string): Promise<vehicleMasterModel> {
  //   try {
  //     // const responses = await client.graphql({
  //     //   query: combine.query,
  //     //   variables: { ex_data: status },
  //     // });

  //     // console.log('Combine_response', responses);

  //     // Prepare the GraphQL query operation
  //     const operation = graphqlOperation(filterByVehicleMasterQueries.query, {
  //       ex_data: status,
  //     });

  //     // Perform the GraphQL query using Amplify API
  //     // listVehicleMasters: vehicleMasterModel;
  //     const response: GraphQLResult<{
  //       listVehicleMasters: vehicleMasterModel;
  //     }> = (await client.graphql(operation)) as any;
  //     console.log(':::RESPOS', response.data);

  //     if (response.data) {
  //       // Extract the result from the response
  //       const returnResponse = response.data.listVehicleMasters;
  //       return returnResponse;
  //     } else {
  //       throw new Error('GraphQL operation returned no data.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching car request status:', error);
  //     throw error;
  //   }
  // }

  // async fetchCarRequestStatus(carId: string): Promise<CpAssignedCar> {
  //   var status = carId;
  //   try {
  //     // Prepare the GraphQL query operation
  //     const operation = graphqlOperation(cpStatusFilter.query, {
  //       status,
  //     });

  //     // Perform the GraphQL query using Amplify API
  //     const response: GraphQLResult<{ carRequestStatus: CpAssignedCar }> =
  //       (await client.graphql(operation)) as any;
  //     console.log(':::RESPOS', response);

  //     if (response.data) {
  //       // Extract the result from the response
  //       const returnResponse: CpAssignedCar = response.data.carRequestStatus;
  //       return returnResponse;
  //     } else {
  //       throw new Error('GraphQL operation returned no data.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching car request status:', error);
  //     throw error;
  //   }
  // }

  /****************************************************************************************
   * Drivers
   ***************************************************************************************/
  public async filterByDriversVehicleMaster(
    userID: string
  ): Promise<daVehicleMasterModel[]> {
    const tablename = TableConstants.DaVehicleMaster;
    const endpoint = `${url}/${tablename}?data->>user_id=eq.${encodeURIComponent(
      userID
    )}`;
    try {
      const response = await this.httpUtils.get<daVehicleMasterModel[]>(
        endpoint
      );
      if (response) {
        console.log("Data:", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching driver vehicle master:", error);
      throw error;
    }
  }

  /****************************************************************************************
   * CAP ASSITS - CAR
   ***************************************************************************************/
  public async getCpAssignedCar(
    offset: number = 0,
    limit: number = 100
  ): Promise<any[]> {
    const tablename = TableConstants.fngetCpAssignedCarQueries;
    // const endpoint = `${url}/${tablename}?offset=${offset}&limit=${limit}`;
    const endpoint = `${url}/${tablename}`;
    try {
      const response = await this.httpUtils.get<any[]>(endpoint);
      const items = response.map((row) => {
        const item = { ...row.assigned_car };
        item.user = row.user_data;
        item.car = row.car_data;
        if (item.car) {
          item.car.agency = row.agency_data;
        }
        return item;
      });
      if (items) {
        return items;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching assigned cars:", error);
      throw error;
    }
  }
  public async filterByAssignedCarBasedonRnID(
    offset: number = 0,
    limit: number = 100,
    rnID: string
  ): Promise<CpAssignedCarModel[]> {
    const tablename = TableConstants.CpAssignedCar;
    // Filter by rn_id and status=ASSIGN
    const endpoint = `${url}/${tablename}?data->>rn_id=eq.${rnID}&data->>status=eq.${AppConstants.REQUEST_STATUS.ASSIGN}`;
    try {
      const response = await this.httpUtils.get<CpAssignedCarModel[]>(endpoint);
      if (response) {
        console.log("Data:", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching car request status:", error);
      throw error;
    }
  }

  /****************************************************************************************
   * USER SERVICES
   ***************************************************************************************/
  public async filterByUser(
    id: string,
    userName?: string
  ): Promise<RncUsersModel[]> {
    const tablename = TableConstants.RncUsers;
    let endpoint = `${url}/${tablename}?`;
    const params: string[] = [];
    if (id) {
      params.push(`id=eq.${id}`);
    }
    if (userName) {
      params.push(`data->>user_name=eq.${userName}`);
    }
    endpoint += params.join("&");
    try {
      const response = await this.httpUtils.get<RncUsersModel[]>(endpoint);
      if (response) {
        console.log("Data:", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      throw error;
    }
  }
  /****************************************************************************************
   * VECHICLE MAINTENANCE SERVICES
   ***************************************************************************************/
  public async getcpVehicleMaintenanceListService(): Promise<
    ListCpVehicleMaintenanceModel[]
  > {
    const tablename = TableConstants.CpCarMaintenance;
    const endpoint = `${url}/${tablename}`;
    try {
      const response = await this.httpUtils.get<
        ListCpVehicleMaintenanceModel[]
      >(endpoint);
      if (response) {
        console.log("[cpVehicleMaintenance_list_RESPONSE]", response);
        return response;
      } else {
        throw new Error(
          "REST operation returned no data cap assist vehicle list."
        );
      }
    } catch (error) {
      console.error(
        "Error fetching cap assist vehicle list request status:",
        error
      );
      throw error;
    }
  }

  public async updatecpVehicleMaintenanceRequestService(
    updateCpRequest: any
  ): Promise<boolean> {
    const functionName = TableConstants.fnUpdateCpVehicleMaintenance;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateCpRequest.id,
      updates: {
        comments: updateCpRequest.comments,
        request_status: updateCpRequest.request_status,
        updated_date: this.updated_date,
        ex_data: updateCpRequest.ex_data,
        sla_date: updateCpRequest.sla_date,
      },
      p_updated_date: new Date().toISOString(),
    };

    try {
      const response = await this.httpUtils.post(endpoint, payload);
      return !!response;
    } catch (error) {
      console.error("Error updating vehicle maintenance request:", error);
      return false;
    }
  }

  /****************************************************************************************
   * DA VEHICLE MASTER
   ***************************************************************************************/

  public async getDaVehicleMaster(): Promise<daVehicalMasterModel[]> {
    const functionName = TableConstants.fnGetDaVehicleMaster;
    const endpoint = `${url}/${functionName}`;

    try {
      const response = await this.httpUtils.post<daVehicalMasterModel[]>(endpoint, []);
      if (response) {
        return response.map((row) => ({
          ...row.vehicle_master,
          driver: row.user_detail
        }));
      } else {
        throw new Error("REST operation returned no data daVehicleMasterlist.");
      }
    } catch (error) {
      console.error("Error fetching daVehicleMasterlist status:", error);
      throw error;
    }
  }
  public async getReturnAttachments(data: any): Promise<CpAssignedCar[]> {
    const functionname = TableConstants.fngetCpAssignedCar;
    const endpoint = `${url}/${functionname}?p_car_id=${data.car_id}`;
    try {
      const response = await this.httpUtils.get<any[]>(endpoint);
      const items = response.map((row) => {
        const item = { ...row.assigned_car };
        item.user = row.user_data;
        return item;
      });
      if (items) {
        return items;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching assigned cars:", error);
      throw error;
    }
  }

  getRandomPassword() {
    var length = 5,
      charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  sendResetPasswordEmail(data: any) {
    try {
      let resetEmailUrl =
        environment.emailUrl[window.location.origin] +
        "/" +
        encodeURIComponent(data.firstname).toString() +
        "/" +
        encodeURIComponent(data.credential).toString() +
        "/" +
        encodeURIComponent(data.emailaddress).toString() +
        "/" +
        encodeURIComponent(data.userid);
      return this.http.get(resetEmailUrl, {});
    } catch (error) { }
  }

    public async updateVehicle(
    updateObj: any
  ): Promise<any> {
    
    const functionName = TableConstants.fnUpdateVehicleMasterStatus;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateObj.id,
      updates: {
        id: updateObj.id,
        veh_reg_id: updateObj.veh_reg_id,
        policy_no: updateObj.policy_no,
        policy_from: updateObj.policy_from,
        policy_to: updateObj.policy_to,
        car_type: updateObj.car_type
      },
      p_updated_date: new Date().toISOString(),
    };

    try {
      const response = await this.httpUtils.post(endpoint, payload);
      return !!response;
    } catch (error) {
      console.error("Error updating vehicle maintenance request:", error);
      return false;
    }
  }

  async updateDaVehicleMaster(masterData): Promise<any>  {
      const functionName = TableConstants.fnUpdateVehicleMasterGeoFenceLimit;
      const endpoint = `${url}/${functionName}`;
      const payload = {
        p_id: masterData.id,
        updates: {
          id: masterData.id,
          ex_data: masterData.ex_data,
        },
        p_updated_date: new Date().toISOString(),
      };

      try {
        const response = await this.httpUtils.post(endpoint, payload);
        return !!response;
      } catch (error) {
        console.error("Error updating vehicle maintenance request:", error);
        return false;
      }
  }

}
